import { FC } from 'react';
import {MetaTitle} from "./MetaTitle";
import {MetaTags} from "./MetaTags";

interface MetaTagProps {
    children: any,
}

interface MetaTagInterface extends FC<MetaTagProps> {
    Title: typeof MetaTitle;
    Tag: typeof MetaTags;
}

const MetaTag: MetaTagInterface = ({children}) => {
    return children;
}

MetaTag.Title = MetaTitle;
MetaTag.Tag = MetaTags;
export default MetaTag;
